import accountApi from '@/config/api/account';
import additionalApi from '@/config/api/additionals';
import bookingApi from '@/config/api/booking';
import buildingsApi from '@/config/api/buildings';
import documentsApi from '@/config/api/documents';
import eventsApi from '@/config/api/events';
import fireApi from '@/config/api/fire';
import newsApi from '@/config/api/news';
import pagesApi from '@/config/api/pages';
import projectsApi from '@/config/api/projects';
import promoApi from '@/config/api/promotions';
import propertiesApi from '@/config/api/properties';
import surveyApi from '@/config/api/survey';
import templatesApi from '@/config/api/templates';
import usersApi from '@/config/api/users';

import legalDocumentsApi from './legalDocuments';

const config = {
  ...accountApi,
  ...bookingApi,
  ...documentsApi,
  ...pagesApi,
  ...projectsApi,
  ...propertiesApi,
  ...usersApi,
  ...surveyApi,
  ...additionalApi,
  ...fireApi,
  ...templatesApi,
  ...eventsApi,
  ...buildingsApi,
  ...newsApi,
  ...promoApi,
  ...legalDocumentsApi,
};

export default config;
